import React from 'react';

import SelectField from '../../../../components/inputs/selectField';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField';
import ViewsTable from '../../../../components/tables/ViewsTable';
import API from '../../../../utils/API';
const statusOptions = [
    { label: 'imported', value: 'imported' },
    { label: 'invited', value: 'invited' },
    { label: 'registered', value: 'registered' },
    { label: 'not attending', value: 'not attending' },
    { label: 'checked in', value: 'checked in' },
    { label: 'incomplete', value: 'incomplete' },
    { label: 'entered through SSO', value: 'entered through SSO' },
    { label: 'removed', value: 'removed' },
    { label: 'Did not attend', value: 'did not attend' },
    { label: 'Cancelled', value: 'cancelled' },
];

const roleOptions = [
    { label: '', value: '' },
    { label: 'Guest', value: 'guest' },
    { label: 'Staff', value: 'staff' },
    { label: 'Admin', value: 'admin' },
    { label: 'Speaker', value: 'speaker' },
    { label: 'Attendee', value: 'attendee' },
    { label: 'Vendor', value: 'vendor' },
];

const getMeta = (url, cb) => {
    const img = new Image();
    img.onload = () => cb(null, img);
    img.onerror = (err) => cb(err);
    img.src = url;
};

class AssignToAttendees extends React.Component {
    constructor(props) {
        super(props);
        const columns = {
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email'
        };
        const columnTypes = {
            firstName: 'string',
            lastName: 'string',
            email: 'string'
        };
        const toggledColumns = {};
        const normalizedColumns = Object.keys(columns).map((cfc) => {
            toggledColumns[cfc] = true;
            return {
                label: columns[cfc],
                key: cfc,
                value: cfc,
                type: columnTypes[cfc],
                sortAsc: false,
                sortDesc: false
            };
        });
        this.state = {
            selectedStatus: statusOptions[0],
            selectedRole: roleOptions[0],
            updateResults: null,
            submitting: false,
            invalid: false,
            success: false,
            selectedValue: {},
            requiredFields: {
                selectedValue: false
            },
            editedValues: {},
            columnSearchTerm: '',
            selectedColumns: {},
            activeCategories: [],
            loading: true,
            selectedSection: 0,
            isConfirmation: false,
            removedProperties: {},
            beginningValues: {},
            editedProperties: [],
            columnTypes: columnTypes,
            columns: columns,
            normalizedColumns: normalizedColumns,
            toggledColumns: toggledColumns,
            checkedAttendees: {},
            searchTerm: ''
        };
    }

    componentDidMount() {
        const { categoryColumns, selectedView, bannedProperties } = this.props;
        let activeCategories = {};
        let editedValues = {};

        this.setState({ loading: false, activeCategories: Object.keys(activeCategories), beginningValues: editedValues, editedValues: editedValues })
    }
    handleStatusChosen = (e) => {
        this.setState({ selectedValue: e });
    };

    updatedEditedValue = (key, value) => {
        this.setState({ editedValues: { ...this.state.editedValues, [key]: value } });
    }

    submit = async () => {
        const { checkedAttendees } = this.state;

        this.setState({ submitting: true, success: false });
        let selectedAttendeeIds = Object.keys(checkedAttendees);
        let filteredSelectedAttendees = this.props.attendees.filter((attendee) => {
            return selectedAttendeeIds.includes(attendee._id);
        }).map((attendee) => {
            return {
                _id: attendee._id,
                firstName: attendee.firstName,
                lastName: attendee.lastName,
                email: attendee.email,
            };
        });
        this.props.batchUpdateAttendees(filteredSelectedAttendees, () => {
            this.setState({ submitting: false, success: true });
            this.props.toggle();
        });


    };

    updateSelectedSection = (index) => {
        this.setState({ selectedSection: index });
    };

    updatedCheckedAttendees = (checked) => {
        this.setState({ checkedAttendees: checked });
    };

    render() {
        const {
            isOpen,
            toggle,
            checkedEntries,
            attendees
        } = this.props;

        const {
            submitting,
            success,
            loading,
            isConfirmation,
            editedProperties,
            normalizedColumns,
            toggledColumns,
            selectedColumnSort,
            searchTerm,
            sortDesc,
            columnWidth,
            columns,
            checkedAttendees
        } = this.state;
        let availableAttendees = attendees;
        let data = availableAttendees;
        if (searchTerm.length > 0) {
            const searchTerms = searchTerm.toLowerCase().split(' ');
            searchTerms.forEach((term) => {
                if (term != '') {
                    data = data.filter((entry) => {
                        let found = false;
                        Object.keys(columns).forEach((key) => {
                            if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
                                found = true;
                            }
                        });
                        return found;
                    });
                }
            });
        }
        if (selectedColumnSort) {
            data = availableAttendees.sort((a, b) => {
                const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                    switch (columnType) {
                        case 'string':
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                        case 'number':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        case 'date':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'time':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'boolean':
                            const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                            const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                            return a1.localeCompare(b1);
                        default:
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                    }
                } else if (a[selectedColumnSort.key]) {
                    return 1;
                }
                return -1;
            });

            availableAttendees = sortDesc ? availableAttendees.reverse() : availableAttendees;
        }

        return (

            <div>
                {!loading && <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Assign to Attendees"}
                    bodyHeaderText={''}
                    bodyExtraText={<p className='pb-20' style={{ color: '#999999', marginTop: 0 }}>Select attendees to assign to the selected inventory.</p>}
                    bodyContent={() => {
                        return (
                            <div style={{ paddingRight: 5 }}>
                                <InputField
                                    classes="viewSearch"
                                    placeholder="Search "
                                    clickIcon={true}
                                    required={true}
                                    value={searchTerm}
                                    onChange={(e) => {
                                        this.setState({ searchTerm: e.target.value });
                                    }}
                                    prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
                                    inputIcon={searchTerm !== '' &&
                                        <i
                                            onMouseDown={() => this.setState({ searchTerm: '', searching: false })}
                                            //onClick={() => this.setState({ searchTerm: '', searching: false })}
                                            className="las la-times-circle"
                                            style={{ visibility: searchTerm == '' ? 'hidden' : 'visible' }}
                                        />}
                                />
                                <ViewsTable
                                    title="Attendees"
                                    style={{ margin: 0, height: 500 }}
                                    classes={"fit"}
                                    columns={normalizedColumns}
                                    toggledColumns={toggledColumns}
                                    data={data}
                                    mainColumnActive={false}
                                    columnWidth={columnWidth}
                                    checked={this.state.checkedAttendees}
                                    checkRow={(entryId) => {
                                        const checked = this.state.checkedAttendees;
                                        checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
                                        this.updatedCheckedAttendees(checked);
                                    }}
                                    checkAllRows={(entryIds) => {
                                        let checked = this.state.checkedAttendees;
                                        entryIds.length > 0
                                            ? entryIds.forEach((entryId) => {
                                                checked[entryId] = true;
                                            })
                                            : (checked = {});
                                        this.updatedCheckedAttendees(checked);
                                    }}
                                    sortData={this.sortData}
                                />{' '}
                            </div>
                        )
                    }
                    }
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Add' : 'Adding...'}
                    cancelButtonLabel={success ? 'Close' : isConfirmation ? 'Back' : false}
                    cancelOnClick={isConfirmation ? () => {
                        this.setState({ isConfirmation: false, removedProperties: {} })
                    } : false}
                    actionButton={() => this.submit()}
                    submitting={submitting}
                    actionButtonDisabled={submitting || success}
                ></FieldModal >}
            </div >
        )

    }
}

export default AssignToAttendees;
